export default {
  /**
   * returns the list of all the geoData
   */
  getGeoDataList: state => {
    return state.geoDataById.map(id => state.getGeoData[id]);
  },

  /**
   * Get the geodata object
   */
  getGeoData: state => {
    return state.getGeoData;
  },
  /**
   * Returns the search history
   */
  getHistory: state => {
    return state.history;
  },
};
